<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()
const getTranslate = computed(() => translaterStore.getTranslate)

</script>

<template>
    <div class="uta-car-ecus-descr">

        <!-- Блоки -->
        <div class="uta-car-ecus-descr__group uta-car-ecus-descr__group--colors">

            <div class="uta-car-ecus-descr__group-title">
                {{ getTranslate.ECUS_DESCR_BG }}
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--active"></span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_BG_ONLINE }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr"></span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_BG_OFFLINE }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--error"></span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_BG_ERROR }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--notinstalled"></span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_BG_NO_INFO }}</span>
            </div>

        </div>

        <!-- Метки -->
        <div class="uta-car-ecus-descr__group uta-car-ecus-descr__group--badges">

            <div class="uta-car-ecus-descr__group-title">
                {{ getTranslate.ECUS_DESCR_BADGES }}
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--active">
                    <span class="uta-car-ecus-link__badges">
                        <div class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-passive">9</div>
                    </span>
                </span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_ICON_PASSIVE }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--error">
                    <span class="uta-car-ecus-link__badges">
                        <div class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-active">5</div>
                    </span>
                </span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_ICON_ERROR }}</span>
            </div> 

        </div>

        <!-- GNSS -->
        <div class="uta-car-ecus-descr__group uta-car-ecus-descr__group--badges">

            <div class="uta-car-ecus-descr__group-title">
                {{ getTranslate.ECUS_DESCR_GNSS }}
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--active">
                    GNSS
                    <div class="uta-car-ecus-descr__group-item-badge uta-car-ecus-descr__group-item-badge--online">
                        <span class="material-icons" style="font-size: 0.75rem;">sensors</span>
                    </div>
                </span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_GNSS_ONLINE }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--active">
                    GNSS
                    <div class="uta-car-ecus-descr__group-item-badge uta-car-ecus-descr__group-item-badge--nosatellites">
                        <span class="material-icons" style="font-size: 0.75rem;">sensors</span>
                    </div>
                </span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_GNSS_NOSATELLITES }}</span>
            </div>

            <div class="uta-car-ecus-descr__group-item">
                <span class="uta-car-ecus-descr__group-item-icon uta-car-ecus-link uta-car-ecus-link--descr uta-car-ecus-link--active">
                    GNSS
                    <div class="uta-car-ecus-descr__group-item-badge uta-car-ecus-descr__group-item-badge--offline">
                        <span class="material-icons" style="font-size: 0.75rem;">sensors</span>
                    </div>
                </span>
                <span class="uta-car-ecus-descr__group-item-text">{{ getTranslate.ECUS_DESCR_GNSS_OFFLINE }}</span>
            </div>

        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/ecus/ecus-descr';
</style>